import { render, staticRenderFns } from "./supplierPrice.vue?vue&type=template&id=2bf88b65&scoped=true"
import script from "./supplierPrice.vue?vue&type=script&lang=js"
export * from "./supplierPrice.vue?vue&type=script&lang=js"
import style0 from "./supplierPrice.vue?vue&type=style&index=0&id=2bf88b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf88b65",
  null
  
)

export default component.exports